import { NgModule } from '@angular/core';
import { IconDirective } from './icon.directive';


@NgModule({
  declarations: [IconDirective],
  imports: [],
  exports: [IconDirective]
})
export class IconModule {
}
